import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import idx from 'idx';
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import { setCookie, removeCookie } from "../../../utils/cookies";
import { colors, MIN_INTERNET, localStorageConstants } from "../../layout/constants";
import Modal from './modal';
//import Video from "../video_welcome";
import VideoStarted from "../video_started";
import CheckSettings from "../checkSettings";
import { getCheckMicrophone } from "../../../services/test";
import { logoutUser } from "../../../services/users";

import camaraPermission from "../../../assets/images/camaraPermission.png";

let askTimes = 0, videoStream;
const WelcomeView = ({ aboutTest, getTest, startedTest, drawQuestions }) => {
  //const startedTest = localStorage.getItem(localStorageConstants.startTest);
  // Redux
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  // State
  const [rulesAcepted, setRulesAcepted] = useState(false);
  const [checkedVideo, setCheckedVideo] = useState(false);
  const [allowCameraAcepted, setAllowCameraAcepted] = useState(false);
  const [hadPermissions, setHadPersmissions] = useState(false);
  const [checkInternet, setCheckInternet] = useState(false);
  const [valuesInternet, setValuesInternet] = useState();
  const [showSpeedInternet, setShowSpeedInternet] = useState(false);
  const [askImage, setAskImage] = useState(false);
  const [loadCamera, setLoadCamera] = useState(false);
  const [showCheckSettings, setShowCheckSettings] = useState(false);
  const [microphoneOK, setMicrophoneOK] = useState(false);
  const [checkMicrophone, setCheckMicrophone] = useState(false);
  const [sendPictureWithOutMicrophone, setSendPictureWithOutMicrophone] = useState(false);

  useEffect(() => {
    navigator.permissions.query({ name: "camera" }).then(res => {
      if (res.state == "granted") {
        navigator.permissions.query({ name: "microphone" }).then(resaudio => {
          if (resaudio.state == "granted") {
            setHadPersmissions(true);
            setAllowCameraAcepted(true);
            setCheckedVideo(true);
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    //if(!user?.sedema_microphone_unactive)
    functionCheckMicrophone(user);
  }, []);

  useEffect(() => {
    if(!user?.microphone_unactive) {
      setCheckMicrophone(true);
    } else {
      setCheckMicrophone(false);
    }
  },[user]);

  useEffect(() => {
    if (rulesAcepted) {
      setCookie("timer", 90);
    }
  }, [rulesAcepted]);

  useEffect(() => {
    if (checkedVideo) {
      allowCameraFunc();
    }
  }, [checkedVideo]);

  useEffect(() => {
    if (allowCameraAcepted) {
      setShowCheckSettings(true);
      //alert('aceptado camara');
    }
  }, [allowCameraAcepted]);

  useEffect(() => {
    setRulesAcepted(startedTest);
  }, [startedTest]);

  const functionCheckMicrophone = async (userInfo) => {
    try {
      const respMP = await getCheckMicrophone();

      if(userInfo?.microphone_unactive){
        setCheckMicrophone(false);
      } else if(!userInfo?.microphone_unactive){
        setCheckMicrophone(true)
      }else if(respMP?.microphone_unactive) 
        setCheckMicrophone(false)
      else if(!respMP?.microphone_unactive) setCheckMicrophone(true);
    } catch (error) {
      setCheckMicrophone(false);
      console.error(error);
      //setMicrophoneOK(true);
    }
  };

  const allowCameraFunc = async () => {
    if (!allowCameraAcepted && !hadPermissions) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: { facingMode: "user" },
        });
        setAllowCameraAcepted(true);
        setHadPersmissions(true);

        videoStream = stream;
        videoStream.getTracks().forEach(function (track) {
          track.stop();
        });
      } catch (error) {
        askTimes++;
        setAllowCameraAcepted(false);
        setCheckedVideo(false);
      }
    }

  };

  const start = () => {
    if(!checkMicrophone || startedTest)
      setSendPictureWithOutMicrophone(true);
    if (startedTest) drawQuestions();
    else setAskImage(true);
  };

  const getImage = (videoInfo, imgInfo) => {
    getTest(videoInfo, imgInfo);
    localStorage.setItem(localStorageConstants.startTest, true);
  };

  const logout = () => {
		removeCookie("userId");
		removeCookie("mentaliaUserToken");
		removeCookie("timer");
		removeCookie("email");
		logoutUser();

		// // Redux action
		dispatch({
			type: "SET_USER_INFO",
			payload: {},
		});
	};

  const valitationMicrophone = checkMicrophone ? microphoneOK ? true : false : true;

  return (
    <WelcomeStyled>
      <h2 className="test-title">
        Hola {user.name}, te damos la bienvenida a tu evaluación: <br />
        <span className="evaluation-name"> {user.evaluationName}</span>
      </h2>
      {!startedTest &&
        <div>
          <p>Si no eres <strong>{user.name}</strong> <label onClick={logout} style={{color: 'blue', cursor: 'pointer'}}>Cierra la sesión</label></p>
        </div>
      }
      <p>
        Te pedimos leer y seguir las siguientes instrucciones
      </p>
      <ol className="rules">
        <li>
        Debes responder considerando lo aprendido de los cursos del programa que estudiaste.
        </li>
        <li>
          Deberás permitir el acceso a tu cámara y micrófono en todo momento para
          poder estar en constante monitoreo, de lo contrario no podrás acceder a la evaluación.
        </li>
        <li>
        Queda estrictamente prohibido hablar, hacer uso de audífonos, teléfonos celulares, equipo electrónico adicional, apoyarse de cualquier material físico y/o desde luego copiar.
        </li>
        <li>Tendrás 90 segundos para responder cada una de las preguntas.</li>
        <li>
          De no responder una pregunta en el tiempo indicado esta se tomará como respuesta incorrecta.
        </li>
        <li>Tus respuestas y avance serán guardados
          automáticamente.</li>
        <li>
          Es necesario tomar la evaluación en una computadora personal o en una tableta con algún
          soporte para que permanezca estática.
        </li>
        <li>
          La evaluación debe ser tomada en un explorador Google Chrome para
          tener la mejor experiencia.
        </li>
        <li>
          La duración máxima de esta evaluación es de 2 horas, por favor revisa que tu
          dispositivo tenga la suficiente batería o esté conectado a la electricidad.
        </li>
        <li>
          Una vez iniciada la
          evaluación no debes cerrar el explorador ni cambiar de ventana, de lo contrario las preguntas podrán ser invalidadas y
          tu prueba podrá ser suspendida.
        </li>
        
        <li>
          Debes tener un
          buen internet de cuando menos 20mb de velocidad para poder tomar la prueba sin contratiempos.
        </li>
        <li>
          Deberás
          estar en un espacio amplio sin otras personas cerca de ti, esto con la finalidad de evitar que se pueda anular la
          prueba.
        </li>
        <li>
          Tu perfil de evaluación es{" "}
          <span className="profile">{user.profileName}</span>, si está equivocado comunícaselo al personal de
          Mentalia antes de comenzar para poder corregirlo.
        </li>
      </ol>
      
      <div className="check-row">
        <Checkbox
          color="primary"
          checked={rulesAcepted}
          onChange={(event) => setRulesAcepted(event.target.checked)}
        />
        <p>He leído, entiendo y me comprometo a seguir las instrucciones.</p>
      </div>
      {showSpeedInternet &&
        <div className="check-row">
          <Checkbox
            color="primary"
            checked={checkInternet && valuesInternet === undefined || valuesInternet > MIN_INTERNET}
            onChange={(event) => setCheckInternet(event.target.checked)}
            disabled={valuesInternet > MIN_INTERNET}
          />
          <p>Mi internet tiene una velocidad de <strong>{`${MIN_INTERNET}mb`}</strong> en adelante</p>
        </div>
      }
      <div className="check-row">
        <Checkbox
          color="primary"
          checked={checkedVideo}
          onChange={(event) => setCheckedVideo(event.target.checked)}
          disabled={hadPermissions}
        />
        <p>Quiero activar mi cámara y micrófono para presentar la prueba.</p>
      </div>
      <div className="check-row">
        {askTimes > 2 ? (
          <p className="error">
            Camara desactivada <br /> Si denegaste el permiso por error, puedes
            otorgarlo apretando el simbolo de la camara en la barra de tu
            navegador. <br />
            <br />
            <img src={camaraPermission}></img>
          </p>
        ) : null}
      </div>
      {allowCameraAcepted && !startedTest &&
        <VideoStarted 
          getImage={getImage} 
          askImage={askImage} 
          microphoneOK={microphoneOK}
          sendPictureWithOutMicrophone={sendPictureWithOutMicrophone}
        />
      }
      <Button
        className="select-button"
        //disabled={!rulesAcepted || !allowCameraAcepted || valuesInternet < MIN_INTERNET}
        //disabled={!rulesAcepted || !allowCameraAcepted || !startedTest && !loadCamera}
        disabled={!rulesAcepted || !allowCameraAcepted || !startedTest && !loadCamera && !valitationMicrophone}
        variant="contained"
        color="secondary"
        size="large"
        onClick={start}
      >
        {startedTest ? 'Continuar evaluación' : 'Comenzar evaluación'}
      </Button>
      {showSpeedInternet && checkInternet && <Modal setValuesInternet={setValuesInternet} setCheckInternet={setCheckInternet} />}

      {checkMicrophone &&
        <div>
          {!microphoneOK && rulesAcepted && showCheckSettings &&
            <CheckSettings
              setMicrophoneOK={setMicrophoneOK}
            />
          }
        </div>
      }
    </WelcomeStyled>
  );
};

const WelcomeStyled = styled.section`
	box-sizing: border-box;
	justify-content: center;
	display: flex;
	min-height: calc(100vh - 80px);
	flex-direction: column;
	// text-align: center;
	padding-bottom: 2em;
	width: 100%;
	margin: 0 auto;


	.test-title {
		// font-size: 1.2rem;
		text-align: center;
		font-weight: 400;
		margin-top: 2rem;
	}

	.evaluation-name  {
		font-weight: 600;
	}

	.rules {
		text-align: left;
		padding: 0;
		margin-top: 0;
		li {
			margin: 1em;
		}
	}

	.profile {
		font-weight: 600;
	}

	.check-row {
		display: flex;
	}

	.select-button {
		margin: 1em auto;
	}

	.MuiButton-contained {
		box-shadow: none;
		// font-size: 20px;
		font-weight: 600;

		:hover {
			box-shadow: none;
		}
	}

	.MuiButton-containedSecondary {
		background-color: ${colors.primary};
		width: 100%;

		:hover {
			background-color: ${colors.primaryDark};
		}
	}
`;

export default WelcomeView;
